import {createSelector} from 'reselect';
import {AppState} from '../../../index';

export const themeSelector = () =>
  createSelector(
    (state: AppState) => state.runtime.theme.settings!,
    (item) => item,
  );
